<obg-progress-bar
	[mode]="progressBarMode"
	[value]="currentProgress"
	[maxValue]="endsOn"
	hideValues
	[options]="{ type: 'percentage'}"
>
</obg-progress-bar>
<div>{{ timeRemaining }}</div>
